import React from 'react';
import { Link } from 'react-router-dom';

function TermsPage() {
  return (
    <div className="min-h-screen bg-cream-100">
      {/* Navigation */}
      <nav className="border-b border-cream-300">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src="/assets/logo_2.png" alt="QuickSheet Logo" className="h-8 w-8" />
            <span className="font-bold text-xl text-navy-900">QuickSheet</span>
          </Link>
          <Link to="/" className="text-sm text-gray-500 hover:text-navy-900 transition">
            Back to home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-serif font-bold text-navy-900 mb-2">Terms &amp; Conditions</h1>
        <p className="text-sm text-gray-500 mb-10">Last updated: February 16, 2026</p>

        <div className="space-y-8 text-gray-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing or using QuickSheet ("the Service"), you agree to be bound by these Terms &amp; Conditions. If you do not agree, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">2. Description of Service</h2>
            <p>
              QuickSheet is a web-based spreadsheet viewer that allows you to open, view, and analyze spreadsheet files. Files opened locally are processed entirely in your browser and are not uploaded to our servers unless you explicitly choose to save them to the cloud.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">3. User Accounts</h2>
            <p>
              Some features require creating an account. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. You must provide accurate information when creating an account.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">4. Privacy &amp; Data</h2>
            <p>
              Files processed locally never leave your browser. Cloud-stored files are encrypted and stored securely. We do not sell, share, or use your data for advertising purposes. You may delete your cloud data at any time.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
              <li>Use the Service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any part of the Service</li>
              <li>Interfere with or disrupt the Service's infrastructure</li>
              <li>Upload malicious files or content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">6. Intellectual Property</h2>
            <p>
              The Service, including its design, logos, and code, is owned by QuickSheet. Your data remains yours — we claim no ownership over files you upload or create.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">7. Service Availability</h2>
            <p>
              We strive to keep QuickSheet available at all times but do not guarantee uninterrupted access. The Service is provided "as is" without warranties of any kind, express or implied.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, QuickSheet shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">9. Changes to Terms</h2>
            <p>
              We may update these terms from time to time. Continued use of the Service after changes are posted constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-serif font-semibold text-navy-900 mb-2">10. Contact</h2>
            <p>
              If you have questions about these terms, please reach out via the feedback button within the app.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
